export default __webpack_public_path__ + "static/media/whiteTick.5f00ea4a.svg";